import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.css"; // requires a loader
import { nanoid } from '@reduxjs/toolkit';
//import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import{
    createStyles,
    Image
} from '@mantine/core';
//below:image imports

import crypto_symbols from '../assets/crypto_symbols.jpg'
import koenigsegg from '../assets/koenigsegg.jpg'
import pagani from '../assets/pagani.jpg'
import mustangs_rear from '../assets/mustangs_rear.jpg'
import porsche from '../assets/porsche.jpg'
import thunderbird_tail_light from '../assets/thunderbird_tail_light.jpg'
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg'


//trying react-image gallery (if good will replace the current carousel library)

const useStyles = createStyles((theme) => ({
    card: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
    },
    carousel: {
        width: '300px',
        height: '300px',
        margin: '0 auto'
    }
}));

//export class ResponsiveCarouselCard extends Component {s
export function ResponsiveCarouselCardB({incImages}) {
    const { classes } = useStyles();
    //needed:turn this into box and set a static width
    const carouselChildren = incImages.map((image, index) =>
        <div key={nanoid()}>
            <Image src={image.src} width={300} height={300} mx="auto"/>
        </div>
    )
    return (
        <div className={classes.carousel}>
            <Carousel showStatus={false}>
                {carouselChildren}
            </Carousel>
        </div>
    )
}
